import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { mistakes } from '../data/lessons';
import './Lesson.css';

export default function Mistake() {
  const { id } = useParams();
  const mistake = mistakes.find(m => m.id === parseInt(id));

  const [quizStarted, setQuizStarted] = useState(false);
  const [answers, setAnswers] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [score, setScore] = useState(0);

  if (!mistake) {
    return (
      <div className="lesson-not-found">
        <h2>Article not found</h2>
        <Link to="/mistakes">Back to common mistakes</Link>
      </div>
    );
  }

  const nextMistake = mistakes.find(m => m.id === mistake.id + 1);

  const handleAnswer = (qId, optionIndex) => {
    if (submitted) return;
    setAnswers(prev => ({ ...prev, [qId]: optionIndex }));
  };

  const handleSubmit = () => {
    let correct = 0;
    mistake.quiz.forEach(q => {
      if (answers[q.id] === q.correct) correct++;
    });
    setScore(Math.round((correct / mistake.quiz.length) * 100));
    setSubmitted(true);
  };

  const allAnswered = mistake.quiz.every(q => answers[q.id] !== undefined);

  return (
    <div className="lesson-page">

      <div className="lesson-topbar">
        <div className="lesson-topbar-inner">
          <Link to="/mistakes" className="back-link">← Back to common mistakes</Link>
          <div className="lesson-meta-top">
            <span className="layer-badge">Common mistake</span>
          </div>
        </div>
      </div>

      <div className="lesson-inner">

        <div className="lesson-header">
          <div className="lesson-dots">
            <span>{mistake.duration} min read</span>
            <span className="ldot" style={{ background: '#378ADD' }}></span>
            <span>{mistake.quiz.length} quiz questions</span>
          </div>
          <h1 className="lesson-title">{mistake.title}</h1>
          <p className="lesson-intro">{mistake.content.intro}</p>
        </div>

        <div className="lesson-body">
          {mistake.content.sections.map((section, i) => (
            <div key={i} className="content-section">
              <h2 className="section-heading">{section.heading}</h2>
              <p className="section-body">{section.body}</p>
            </div>
          ))}

          <div className="example-block">
            <div className="example-label">REAL EXAMPLE</div>
            <p className="example-text">{mistake.content.example}</p>
          </div>

          <div className="takeaway-block">
            <div className="takeaway-label">KEY TAKEAWAY</div>
            <p className="takeaway-text">{mistake.content.keyTakeaway}</p>
          </div>

          {!quizStarted ? (
            <div className="quiz-start-card">
              <div className="quiz-start-title">Test your understanding</div>
              <p className="quiz-start-sub">{mistake.quiz.length} questions · takes about 2 minutes</p>
              <button className="quiz-start-btn" onClick={() => setQuizStarted(true)}>
                Start quiz →
              </button>
            </div>
          ) : (
            <div className="quiz-section">
              <div className="quiz-header">Quiz — {mistake.title}</div>

              {mistake.quiz.map((q, qi) => (
                <div key={q.id} className="quiz-question">
                  <div className="q-number">Question {qi + 1} of {mistake.quiz.length}</div>
                  <div className="q-text">{q.question}</div>
                  <div className="q-options">
                    {q.options.map((opt, oi) => {
                      let cls = 'q-option';
                      if (submitted) {
                        if (oi === q.correct) cls += ' correct';
                        else if (answers[q.id] === oi && oi !== q.correct) cls += ' wrong';
                      } else if (answers[q.id] === oi) {
                        cls += ' selected';
                      }
                      return (
                        <div key={oi} className={cls} onClick={() => handleAnswer(q.id, oi)}>
                          <span className="q-option-letter">{String.fromCharCode(65 + oi)}</span>
                          {opt}
                        </div>
                      );
                    })}
                  </div>
                  {submitted && (
                    <div className="q-explanation">
                      <span className="explanation-label">Why: </span>
                      {q.explanation}
                    </div>
                  )}
                </div>
              ))}

              {!submitted ? (
                <button
                  className={`submit-btn ${allAnswered ? 'active' : 'disabled'}`}
                  onClick={allAnswered ? handleSubmit : undefined}
                >
                  {allAnswered ? 'Submit answers →' : `Answer all ${mistake.quiz.length} questions to submit`}
                </button>
              ) : (
                <div className="result-card">
                  <div className="result-score">{score}%</div>
                  <div className="result-label">
                    {score === 100 ? 'Perfect score!' : score >= 66 ? 'Well done!' : 'Good effort — review the explanations above'}
                  </div>
                  <p className="result-sub">
                    You got {mistake.quiz.filter(q => answers[q.id] === q.correct).length} of {mistake.quiz.length} correct
                  </p>
                  {nextMistake ? (
                    <Link to={`/mistakes/${nextMistake.id}`} className="next-btn" style={{ display: 'inline-block', textDecoration: 'none' }}>
                      Next: {nextMistake.title} →
                    </Link>
                  ) : (
                    <Link to="/mistakes" className="next-btn" style={{ display: 'inline-block', textDecoration: 'none' }}>
                      ← Back to all mistakes
                    </Link>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
